import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initPixel } from './lib/pixel';
// Initialize pixel at module level — DOM is ready at this point
initPixel();
render(<App data-id="element-429" />, document.getElementById('root'));